import React, { useContext } from 'react';
import { Button, Dialog as MuiDialog, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { SectionHeader } from '@mummssoftware/common-ui';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { CertContext } from '../../../Context';
import messages from '../CertMessages';

export const LATE_CERT_CONFIRM_ID = 'late-cert-confirm';
export const LATE_CERT_CANCEL_ID = 'late-cert-cancel';

const Dialog = styled(MuiDialog)`
  && .MuiPaper-root.MuiDialog-paper {
    min-width: 300px;
    max-width: 420px;
    overflow: hidden;
  }
`;

const Content = styled.div`
  padding: 8px 16px 12px;
`;

const Warning = styled(Typography)`
  && {
    color: ${({ theme }) => theme.palette.error.main};
    font-weight: bold;
  }
`;

const ButtonBox = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.4rem;
  margin-top: 12px;
`;

/**
 * OP-33276: late-cert warning shown after the doctor clicks Verbal or Sign.
 * The buttons stay visible (disabled) behind it, so the backdrop is invisible.
 * Confirm releases the held click; Cancel (or closing) just dismisses it.
 */
export const LateCertConfirm = ({ open, onConfirm, onCancel, smallWidget }) => {
  const { palette } = useTheme();
  const { dimensions, embedded } = useContext(CertContext);
  // Same placement as MissingParams: an embedded widget positions the dialog
  // over itself instead of the viewport centre.
  const useStyles = makeStyles({
    dialog: {
      position: 'absolute',
      left: dimensions ? dimensions.x : 100,
      top: dimensions ? dimensions.y : 100,
    },
  });
  const classes = useStyles();

  return (
    <Dialog
      classes={embedded && dimensions ? { paper: classes.dialog } : {}}
      open={open}
      onClose={onCancel}
      BackdropProps={{ invisible: true }}
      aria-labelledby="late-cert-confirm-dialog"
    >
      <SectionHeader
        id="late-cert-confirm-dialog"
        title={<FormattedMessage {...messages.confirmLateTitle} />}
      />
      <Content>
        <Warning>
          <FormattedMessage
            {...messages.latePhysCert}
            values={{ type: 'approval' }}
          />
        </Warning>
        <ButtonBox>
          <Button
            id={LATE_CERT_CONFIRM_ID}
            size={smallWidget ? 'small' : 'medium'}
            variant="outlined"
            style={{
              color: palette.error.main,
              borderColor: palette.error.main,
            }}
            onClick={onConfirm}
          >
            <FormattedMessage {...messages.confirmLate} />
          </Button>
          <Button
            id={LATE_CERT_CANCEL_ID}
            size={smallWidget ? 'small' : 'medium'}
            variant="outlined"
            color="primary"
            onClick={onCancel}
          >
            <FormattedMessage {...messages.cancel} />
          </Button>
        </ButtonBox>
      </Content>
    </Dialog>
  );
};

export default LateCertConfirm;
